import {
    curry,
    map,
    when,
    propEq,
    mergeDeepLeft,
    findIndex,
    complement,
    isEmpty,
    is,
    prop
} from 'ramda';
import type { Dealership } from '../api/types/index';
import { userStore } from '../store';

export const alter = curry((list, updatedEntry) =>
    map(
        when(propEq(updatedEntry['@id'], '@id'), mergeDeepLeft(updatedEntry)),
        list
    )
);

export const matchesUserDealerships = (dealership: Dealership) => {
    const { dealerships } = userStore();
    return (
        findIndex(propEq(dealership['@id'], '@id'))(dealerships.list) > -1
    );
};
export const propNotEq = (value: string, key: string) =>
    complement(propEq(value, key));

export const isNotEmpty = complement(isEmpty);

export const isArray = is(Array);

export const getIri = prop('@id');

export const getPlaylist = prop('contentPlaylist');

export const log = (arg: any) => console.log(JSON.stringify(arg));
